// extracted by mini-css-extract-plugin
export default {"head":"AccordeonPanel_head_LWJHb","title":"AccordeonPanel_title_acAPW","body":"AccordeonPanel_body_KnFFB","open":"AccordeonPanel_open_rp6ZQ","compact":"AccordeonPanel_compact_b6f2V"};